export type DiscountAmountType = "Percentage" | "Amount";

export type DiscountId = string;

export interface Discount {
  id: string;
  code: string;
  name: string;
  amount: number;
  amountType: DiscountAmountType;
  minimumPurchaseAmount?: number;
  builtIn: boolean;
  start: Date;
  end: Date;
  created: Date;
  tenantId: string;
  currency: string;
  type: number;
  handoutType?: DiscountHandoutType;
  active: boolean;
}

export enum DiscountHandoutType {
  BeforePurchase = "BeforePurchase",
  AfterPurchase = "AfterPurchase",
  Manually = "Manually"
}

export interface DiscountWriteModel {
  code?: string;
  name?: string;
  amount?: number;
  amountType?: DiscountAmountType;
  minimumPurchaseAmount?: number;
  builtIn?: boolean;
  start?: Date;
  end?: Date;
  type?: number;
  active?: boolean;
  id?: string;
  handoutType?: DiscountHandoutType;
}

export const toWriteModel = (discount: Discount): DiscountWriteModel => {
  return {
    id: discount.id,
    code: discount.code,
    name: discount.name ?? "",
    amount: discount.amount,
    amountType: discount.amountType,
    minimumPurchaseAmount: discount.minimumPurchaseAmount,
    builtIn: discount.builtIn,
    start: discount.start,
    end: discount.end,
    type: discount.type ?? 1,
    handoutType: discount.handoutType,
    active: discount.active
  };
};
